import { AppPlatform } from "@/api/privateRequests/user/appWaitlist";
import { isAndroid, isIOS } from "react-device-detect";

/**
 * The phone the visitor is on, or null on desktop. Android first: isIOS also
 * counts a touch Mac as an iPad.
 */
export const detectPlatform = (): AppPlatform | null =>
  isAndroid ? "android" : isIOS ? "ios" : null;
